import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import { ConfigurationService } from '../../services/configuration.service';
import { WorkspaceStatus } from '@workspaces/models/agent';
import { SKIP_ERROR_HANDLING } from '@workspaces/utils/workspace.interceptor';

@Injectable()
export class WorkspaceAgentService {
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get baseApiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  public triggerAgent(workspaceId: string): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}/trigger-agent`;
    return this.httpClient.post<void>(path, {});
  }
  public getAgentRunStatus(workspaceId: string): Observable<WorkspaceStatus> {
    const path = `${this.baseApiUrl}/${workspaceId}/agent-run-status`;
    const context = new HttpContext();

    context.set(SKIP_ERROR_HANDLING, true);
    return this.httpClient.get<WorkspaceStatus>(path, { context });
  }
}
